const editProfileHelp = [
    {
        id: 1,
        text: "در این صفحه می توانید اطلاعات کاربری خود را در صورت نیاز تغییر دهید"
    }
]

export default editProfileHelp